import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="max-w-3xl mx-auto px-4 py-20 text-center" data-id="element-11">
      <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-6" data-id="element-12">
        Jetzt anfangen: Augenschatten ohne Operation reduzieren
      </h2>
      <p className="text-xl text-slate-600 mb-10 font-medium" data-id="element-13">
        Die Wissenschaft war nie falsch. Sie war nur vergessen.
        <br data-id="element-14" />
        Sie können sie heute Abend wiederentdecken.
      </p>
      <CTAButton className="text-lg px-10 py-5" data-id="element-15">
        → Mehr über Rylte und die Finsen-Galvani-Methode erfahren
      </CTAButton>
    </section>;
}